import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {provideBDSTheme} from "@brightside/angular-bds";
import { provideAppAuth, provideOktaAuth } from '@brightside/core/auth';
import { providePluginExecution } from '@brighthub/plugin';
import { BrightaiModule } from '@brighthub/brightai';
import { provideHttpClient } from '@angular/common/http';
import { provideCopilot } from '@brighthub/copilot';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MessageService } from 'primeng/api';
import { MarkdownModule } from 'ngx-markdown';
// APP ENTRY MODULES NEED TO COME FIRST FOR MENU REGISTRATION
import { MARKED_OPTIONS, MarkedOptions } from 'ngx-markdown';
import { SentryService } from '@brighthub/logging';
import { ClientSearchService } from '@brightai/ui';
import { ClientSessionService } from '@brighthub/uisession';
import { FeedbackService } from '@brighthub/feedback';

export function markedOptionsFactory(): MarkedOptions {
  return {
    gfm: true,
    breaks: true,
  };
}
export const appConfig: ApplicationConfig = {
  providers: [
    SentryService,
    ...BrightaiModule,
    importProvidersFrom([
      MarkdownModule.forRoot({
        markedOptions: {
          provide: MARKED_OPTIONS,
          useFactory: markedOptionsFactory,
        }
      })
    ]),
    MessageService,
    provideHttpClient(),
    // Global NgRx store; feature state (e.g. Copilot) is registered via provideCopilot() and other providers.
    // Routes and feature providers (e.g. BrightaiModule) register their own routes and providers so the root config stays minimal.
    provideStore(),
    provideEffects(),
    providePluginExecution(),
    provideAnimationsAsync(),
    provideBDSTheme(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideOktaAuth(),
    provideAppAuth(),
    ClientSearchService,
    ClientSessionService,
    FeedbackService,
    provideCopilot()
  ],
};
